import { Component, OnInit } from '@angular/core';
import { Button, ButtonColor, ButtonSize } from 'app/store/models/button.model';

@Component({
  selector: 'app-account-settings',
  templateUrl: './account-settings.component.html',
  styleUrls: ['./account-settings.component.scss'],
})
export class AccountSettingsComponent implements OnInit {
  preferencesButtonProperties: Button = {
    color: ButtonColor.BLUE,
    size: ButtonSize.BIG,
    text: 'Update Preferences',
    route: ['/accounts', 'prefs_goals'],
  };

  pipelineButtonProperties: Button = {
    color: ButtonColor.ORANGE,
    size: ButtonSize.BIG,
    text: 'Pipeline features',
    route: ['/accounts', 'prefs_pipeline'],
  };

  constructor() {}

  ngOnInit() {}
}
